import axios from 'axios';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const BASE_URL = `${API_BASE_URL}/accounting/monetary-accounts/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

const monetaryAccountService = {
  listAccounts: (params = {}) => axios.get(BASE_URL, { headers: getHeaders(), params }),

  getAccountById: (id) => axios.get(`${BASE_URL}${id}/`, { headers: getHeaders() }),

  createAccount: (data) => axios.post(BASE_URL, data, { headers: getHeaders() }),

  updateAccount: (id, data) => axios.patch(`${BASE_URL}${id}/`, data, { headers: getHeaders() }),

  // No body: the endpoint flips the flag and returns the updated account.
  toggleActive: (id) =>
    axios.patch(`${BASE_URL}${id}/toggle_active/`, {}, { headers: getHeaders() })
};

export default monetaryAccountService;
